import './slider-product-view-magnific-popup.js';

class SliderProductView {
	constructor() {
		this.selectors = {
			document: document,
			productSlider: '.js-product-slider',
            navSlider: '.js-product-slider-nav',
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
        // Slider for Product Images
        $('.js-product-slider-vertical-4product').is(function(e){
            var productSliderV1 = $(this);
            productSliderV1.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                fade: true,
                infinite: true,
                asNavFor: '.js-product-slider-nav-vertical-4product',
                lazyLoad: 'ondemand'
            });
            var navSliderV1 = $(this).siblings('.js-product-slider-nav-vertical-4product');
            navSliderV1.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                asNavFor: '.js-product-slider-vertical-4product',
                dots: false,
                focusOnSelect: true,
                accessibility: false,
                vertical: true,
                speed: 300,
                arrows: true,
                centerMode: false,
                prevArrow: '<button class="slick-prev slick-prev-vertical"><i class="icon1-arrow-up"></i></button>',
                nextArrow: '<button class="slick-next slick-next-vertical"><i class="icon1-arrow-down"></i></button>',
                lazyLoad: 'ondemand',
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        vertical: false,
                        prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                        nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                    }
                    }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                        prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                        nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                    }
                }],
            });
        });

        $('.js-product-slider-horizontally-4product').is(function(){

            var productSliderV2 = $(this);
            productSliderV2.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                fade: true,
                infinite: true,
                asNavFor: '.js-product-slider-nav-horizontally-4product',
                lazyLoad: 'ondemand'
            });
            var navSliderV2 = $(this).siblings('.js-product-slider-nav-horizontally-4product');
            navSliderV2.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                asNavFor: '.js-product-slider-horizontally-4product',
                dots: false,
                focusOnSelect: true,
                accessibility: false,
                vertical: false,
                speed: 300,
                arrows: true,
                centerMode: false,
                prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                lazyLoad: 'ondemand',
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        vertical: false,
                        prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                        nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                    }
                    }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                        prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                        nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                    }
                }],
            });
        });

        $('.js-product-slider-vertical-3product').is(function(){

            var productSliderV3 = $(this);
            productSliderV3.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                fade: true,
                infinite: true,
                asNavFor: '.js-product-slider-nav-vertical-3product',
                lazyLoad: 'ondemand'
            });
            var navSliderV3 = $(this).siblings('.js-product-slider-nav-vertical-3product');
            navSliderV3.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                asNavFor: '.js-product-slider-vertical-3product',
                dots: false,
                focusOnSelect: true,
                accessibility: false,
                vertical: true,
                speed: 300,
                arrows: true,
                centerMode: false,
                prevArrow: '<button class="slick-prev slick-prev-vertical"><i class="icon1-arrow-up"></i></button>',
                nextArrow: '<button class="slick-next slick-next-vertical"><i class="icon1-arrow-down"></i></button>',
                lazyLoad: 'ondemand',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                        prevArrow: '<button class="slick-prev slick-prev-horizontally"><i class="icon1-arrow-left-2"></i></button>',
                        nextArrow: '<button class="slick-next slick-next-horizontally"><i class="icon1-arrow-right-2"></i></button>',
                    }
                }],
            });
        });

	}
}
new SliderProductView();
